import { forwardRef, useState } from 'react';
import { PiDotsThreeBold } from 'react-icons/pi';
import { QuickSelectionMenu } from '../quick-selection-menu';
import { useContextMenuGestures } from 'src/modules/shared/hooks/use-context-menu-gestures';
import type { ContextMenuSurfaceProps } from 'src/modules/shared/types/context-menu-surface.types';

/** Shared context menu with desktop, touch and keyboard entry points. */
export const ContextMenuSurface = forwardRef<
  HTMLDivElement,
  ContextMenuSurfaceProps
>(function ContextMenuSurface(
  {
    children,
    label,
    items,
    className = '',
    triggerPosition = 'inside-end',
    triggerVariant = 'neutral',
  },
  ref
) {
  const [open, setOpen] = useState(false);
  const gestures = useContextMenuGestures(() => setOpen(true));
  const positionClass =
    triggerPosition === 'outside-start'
      ? 'right-0 top-0 [@media(hover:hover)_and_(pointer:fine)]:right-full [@media(hover:hover)_and_(pointer:fine)]:pr-4'
      : triggerPosition === 'outside-end'
        ? 'right-0 top-0 [@media(hover:hover)_and_(pointer:fine)]:right-auto [@media(hover:hover)_and_(pointer:fine)]:left-full [@media(hover:hover)_and_(pointer:fine)]:pl-4'
        : '-right-1 -top-1';
  return (
    <div
      {...gestures}
      ref={ref}
      role="group"
      aria-label={label}
      tabIndex={-1}
      className={`group/context relative min-w-0 rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-primary-200 ${className}`}
    >
      {children}
      <div
        className={`absolute ${positionClass} invisible [@media(hover:hover)_and_(pointer:fine)]:visible ${open ? '' : '[@media(hover:hover)]:opacity-0 group-hover/context:opacity-100 group-focus-within/context:opacity-100'}`}
      >
        <QuickSelectionMenu
          label={label}
          items={items}
          open={open}
          onOpenChange={setOpen}
          size="2xs"
          shape="round"
          showTooltip={false}
          variant={triggerVariant}
          appearance="ghost"
          icon={<PiDotsThreeBold className="h-4 w-4" />}
        />
      </div>
    </div>
  );
});
